var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.165V1.21a.3.3 0 00-.458-.255L6.438 4.107a.3.3 0 00.013.518l5.105 2.803A.3.3 0 0012 7.165z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1,
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 5,
    height: 1,
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 9,
    height: 1,
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 8,
    height: 1,
    rx: 0.5
  })));
}
export default SvgLimit;